import React, { useState } from "react";
import { createPortal } from "react-dom";

const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

const HoverImagePreview = ({
  src,
  title = "",
  children,
  className = "block",
  previewWidth = 420,
  previewHeight = 300,
}) => {
  const [point, setPoint] = useState(null);

  if (!src) return children;

  const updatePoint = (event) => {
    const rect = event.currentTarget?.getBoundingClientRect?.();
    const hasPointer = Number.isFinite(event.clientX) && Number.isFinite(event.clientY) && event.clientX > 0 && event.clientY > 0;
    setPoint({
      x: hasPointer ? event.clientX : (rect?.right || 0),
      y: hasPointer ? event.clientY : (rect?.top || 0),
    });
  };

  const close = () => setPoint(null);

  const canPortal = point && typeof document !== "undefined";
  const viewportWidth = typeof window !== "undefined" ? window.innerWidth : 1440;
  const viewportHeight = typeof window !== "undefined" ? window.innerHeight : 900;
  const left = canPortal ? clamp(point.x + 18, 12, viewportWidth - previewWidth - 12) : 0;
  const top = canPortal ? clamp(point.y + 18, 12, viewportHeight - previewHeight - 48) : 0;

  return (
    <>
      <span
        className={className}
        onMouseEnter={updatePoint}
        onMouseMove={updatePoint}
        onMouseLeave={close}
        onFocus={updatePoint}
        onBlur={close}
      >
        {children}
      </span>
      {canPortal && createPortal(
        <div
          className="fixed z-[9999] pointer-events-none rounded-md border p-2 shadow-2xl animate-in fade-in duration-150"
          style={{
            left,
            top,
            width: previewWidth,
            maxWidth: "calc(100vw - 24px)",
            borderColor: "var(--color-border-primary)",
            backgroundColor: "var(--color-bg-card)",
          }}
        >
          <img
            src={src}
            alt={title}
            className="w-full rounded object-contain"
            style={{ maxHeight: previewHeight - 44, backgroundColor: "var(--color-bg-primary)" }}
          />
          {title && (
            <div
              className="mt-2 text-xs font-semibold truncate"
              style={{ color: "var(--color-text-secondary)" }}
            >
              {title}
            </div>
          )}
        </div>,
        document.body
      )}
    </>
  );
};

export default HoverImagePreview;
